import React from "react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="btn-icon flex-shrink-0"
      onClick={toggleTheme}
      title={isDark ? "Licht thema" : "Donker thema"}
      aria-label={isDark ? "Licht thema" : "Donker thema"}
    >
      {isDark ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
          <path d="M6.76 4.84 4.96 3.05 3.55 4.46l1.79 1.79 1.42-1.41zM1 13h3v-2H1v2zm10-9h2V1h-2v3zm7.45 1.46 1.79-1.79-1.41-1.41-1.79 1.79 1.41 1.41zM17 13h3v-2h-3v2zm-5 8h2v-3h-2v3zm6.24-2.84 1.41 1.41 1.79-1.79-1.41-1.41-1.79 1.79zM4.96 19.54l1.79-1.79-1.41-1.41-1.79 1.79 1.41 1.41zM12 6a6 6 0 100 12 6 6 0 000-12z" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
          <path d="M12 3a9 9 0 108.95 10.05A7 7 0 0112 3z" />
        </svg>
      )}
    </button>
  );
}
